import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { Sentry } from '.';

/**
 * Syncs the signed-in Clerk user with Sentry so that every captured
 * error is attributed to a specific user in the Sentry dashboard.
 *
 * Must be called inside a component that is a descendant of <ClerkProvider>.
 */
export function useSentryUser() {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;

    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        username: user.username ?? user.fullName ?? undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [isLoaded, user]);
}
